
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/chat-bubble",
      function () {
        return require("private-next-pages/components/chat-bubble.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/chat-bubble"])
      });
    }
  